var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_6950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 19.4641C16.1214 19.4641 19.4632 16.1224 19.4632 12.0001C19.4632 7.87788 16.1214 4.53613 11.9992 4.53613C7.8769 4.53613 4.53516 7.87788 4.53516 12.0001C4.53516 16.1224 7.8769 19.4641 11.9992 19.4641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99931 17.4001L17.3993 12.0001L8.99931 6.60007V17.4001ZM11.9993 24.0001C10.3433 24.0001 8.78331 23.6881 7.3193 23.0521C5.85531 22.4161 4.5833 21.5641 3.5033 20.4841C2.4233 19.4041 1.5713 18.1321 0.935305 16.6681C0.299305 15.2041 -0.0126953 13.6441 -0.0126953 11.9881C-0.0126953 10.3321 0.299305 8.77207 0.935305 7.30807C1.5713 5.84407 2.4233 4.57207 3.5033 3.49207C4.5833 2.41207 5.85531 1.56007 7.3193 0.924074C8.78331 0.288074 10.3433 -0.0239258 11.9993 -0.0239258C13.6553 -0.0239258 15.2153 0.288074 16.6793 0.924074C18.1433 1.56007 19.4153 2.41207 20.4953 3.49207C21.5753 4.57207 22.4273 5.84407 23.0633 7.30807C23.6993 8.77207 24.0113 10.3321 24.0113 11.9881C24.0113 13.6441 23.6993 15.2041 23.0633 16.6681C22.4273 18.1321 21.5753 19.4041 20.4953 20.4841C19.4153 21.5641 18.1433 22.4161 16.6793 23.0521C15.2153 23.6881 13.6553 24.0001 11.9993 24.0001Z",
    fill: "#FF6B00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_6950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(-0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-Icon.b40e1fc7ee25b74966a5fb70d2286774.svg";
export { ForwardRef as ReactComponent };